<template>
  <v-container id="Auditoria" fluid class="py-12 py-md-16">
    <v-row justify="center">
      <v-col cols="12" sm="11" md="10" lg="9" xl="8">
        <v-row>
          <v-col cols="12" class="text-center mb-6 mb-md-8">
            <h2 class="text-h4 text-md-h3 font-heading mb-4">
              Auditoria
            </h2>
            <v-divider class="mx-auto bg-orange" style="max-width: 100px; height: 4px;"></v-divider>
          </v-col>
        </v-row>

        <v-row align="center" class="mb-8">
          <v-col cols="12" md="6" order="1" order-md="1">
            <p class="text-body-1 text-grey-darken-2 mb-4 mb-md-6">
              Nuestro Servicio de Auditoria se basa en la previsión y el control,
              tanto interno como externo de las operaciones de la empresa y su correcta
              registración contable, en cuanto a su existencia, propiedad, integridad,
              valuación y exposición, con el objeto de que la misma sea suministrada en tiempo y forma,
              cumpliendo con plazos legales, Normas Contables y Normas de Auditoria.
            </p>
            <p class="text-body-1 text-grey-darken-2 mb-4 mb-md-6">
              Además, nuestros servicios de auditoria permiten que los propietarios y terceros cuenten
              con información confiable y real de la situación económica y financiera de la empresa.
            </p>

            <v-card variant="tonal" color="orange-lighten-5" class="rounded-lg">
              <v-card-text class="pa-4 pa-md-6">
                <h3 class="text-subtitle-1 font-weight-bold text-grey-darken-3 mb-4">
                  Nuestros principales servicios de Auditoria son:
                </h3>
                
                <div class="d-flex align-start mb-3">
                  <v-icon color="orange" size="small" class="mr-3 mt-1">mdi-arrow-right-thick</v-icon>
                  <span class="text-body-2 text-grey-darken-2">
                    Auditoria Externa de Estados Contables
                  </span>
                </div>
                
                <div class="d-flex align-start mb-3">
                  <v-icon color="orange" size="small" class="mr-3 mt-1">mdi-arrow-right-thick</v-icon>
                  <span class="text-body-2 text-grey-darken-2">
                    Auditoria de Control Interno
                  </span>
                </div>
                
                <div class="d-flex align-start mb-3">
                  <v-icon color="orange" size="small" class="mr-3 mt-1">mdi-arrow-right-thick</v-icon>
                  <span class="text-body-2 text-grey-darken-2">
                    Auditoria de control Lavado de Dinero
                  </span>
                </div>
                
                <div class="d-flex align-start mb-3">
                  <v-icon color="orange" size="small" class="mr-3 mt-1">mdi-arrow-right-thick</v-icon>
                  <span class="text-body-2 text-grey-darken-2">
                    Auditoria de Empresas que cotizan en Bolsa y Bolsas de Comercio
                  </span>
                </div>
                
                <div class="d-flex align-start mb-3">
                  <v-icon color="orange" size="small" class="mr-3 mt-1">mdi-arrow-right-thick</v-icon>
                  <span class="text-body-2 text-grey-darken-2">
                    Asesoramiento y Procesamiento Contable
                  </span>
                </div>
                
                <div class="d-flex align-start">
                  <v-icon color="orange" size="small" class="mr-3 mt-1">mdi-arrow-right-thick</v-icon>
                  <span class="text-body-2 text-grey-darken-2">
                    Certificaciones de ingresos, Manifestaciones de Bienes, Flujos de Fondos, etc.
                  </span>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="6" order="2" order-md="2">
            <v-img
              src="https://www.sydle.com/blog/assets/post/auditoria-interna-649c70daaabaad5335fb1bb6/audit-icon.jpg"
              alt="Auditoria"
              class="rounded-lg"
              cover
              :height="$vuetify.display.smAndDown ? '300' : '500'"
            ></v-img>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
// Component logic here if needed
</script>
